const Logo = () => <img src="/Artificial_Logo_White.png" className="h-12" />;

export default Logo;
